import * as R from "ramda";

import { useAnswerContext } from "contexts/answerContext";
import { Guide } from "types/entities";

import resourceOperations from "./resourceOperations";

const operation = resourceOperations({
  basePath: "/api/guides",
  baseKey: ["guides"],
});

export const useGuides = <T = Guide[]>(opts = {}) =>
  operation.useRead<T>(null, { staleTime: 0, ...opts });

export const useGuide = (id: number, opts = {}) =>
  operation.useRead<Guide>(id, { staleTime: 0, ...opts });

export const useCurrentGuide = (opts = {}) => {
  const { record } = useAnswerContext() as any;
  return useGuide(record?.guide_id, { ...opts, enabled: !!record.guide_id });
};

export const selectPage = (guide: Guide, pageKey: string) => R.path(["pages", pageKey], guide);
